/** @format */

import {TanStackTableData} from 'components/Table/core/types';

import {TableRow} from '../../../types';

export const mapSegmentsToTableData = (segments: TableRow[]): TanStackTableData[] => {
  return segments.map(segment => {
    const baseData: TanStackTableData = {
      number: segment.number,
      segmentName: segment.segmentName,
      groupId: segment.groupId || '',
      campaignId: segment.campaignId,
      campaignName: segment.campaignName,
      accountName: segment.accountName || '',
      kpiFact: segment.kpiFact ?? 0,
      budget: segment.budget ?? 0,
      revenue: segment.revenue ?? 0,
      actionType: segment.actionType || '',
      actionValue: segment.actionValue || '',
      actionUnits: segment.actionUnits || '',
      recommendation: segment.recommendation,
      forecastKpi: segment.forecastKpi ?? 0,
      forecastBudget: segment.forecastBudget ?? 0,
    };

    if (segment.isCollapseSubRows !== undefined) {
      baseData.isCollapseSubRows = segment.isCollapseSubRows;
    }

    if (segment.justification !== undefined) {
      baseData.justification = segment.justification;
    }

    if (segment.subRows !== undefined) {
      baseData.subRows = segment.subRows.map(subRow => ({
        essence: subRow.essence,
        hypothesisDigital: subRow.hypothesisDigital,
        hypothesisTheory: subRow.hypothesisTheory,
        notes: subRow.notes,
      }));
    }

    return baseData;
  });
};
